/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetSearchCatalogLocationRequest,
  TGetSearchCatalogLocationModel,
  IMappers,
  TGetSearchCatalogLocationResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetSearchCatalogLocationResponse } from '../../entities/search_catalog_location/GetSearchCatalogLocationResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSearchCatalogLocationModel(
  parameters: IGetSearchCatalogLocationRequest,
): TGetSearchCatalogLocationModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-temp-layer',
    pathApi: '/v1/get-search-catalog-location/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetSearchCatalogLocationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSearchCatalogLocationRequest;
}

export async function fetchGetSearchCatalogLocation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSearchCatalogLocationOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSearchCatalogLocationResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSearchCatalogLocationModel(parameters),
    config,
  )) as FetchResponse<TGetSearchCatalogLocationResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSearchCatalogLocationResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSearchCatalogLocationResponse>;
}
